(() => {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const random = (min, max) => min + Math.random() * (max - min);
  const randomInt = (min, max) => Math.floor(random(min, max + 1));
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  function createPath(className, d, filterId) {
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('class', className);
    path.setAttribute('d', d);
    if (filterId) path.setAttribute('filter', `url(#${filterId})`);
    return path;
  }

  function pointsToPath(points) {
    return points
      .map((point, index) => `${index === 0 ? 'M' : 'L'}${point.x.toFixed(1)} ${point.y.toFixed(1)}`)
      .join(' ');
  }

  function buildBoltPoints(width, height) {
    const edge = ['top', 'left', 'right'][randomInt(0, 2)];
    let startX;
    let startY;
    let endX;
    let endY;

    if (edge === 'top') {
      startX = random(width * 0.08, width * 0.92);
      startY = -height * 0.08;
      endX = clamp(startX + random(-width * 0.46, width * 0.46), -width * 0.08, width * 1.08);
      endY = height * 1.08;
    } else if (edge === 'left') {
      startX = -width * 0.08;
      startY = random(height * 0.06, height * 0.62);
      endX = width * 1.08;
      endY = clamp(startY + random(height * 0.12, height * 0.46), height * 0.08, height * 0.94);
    } else {
      startX = width * 1.08;
      startY = random(height * 0.06, height * 0.62);
      endX = -width * 0.08;
      endY = clamp(startY + random(height * 0.12, height * 0.46), height * 0.08, height * 0.94);
    }

    const points = [{ x: startX, y: startY }];
    const segments = randomInt(7, 12);

    for (let index = 1; index < segments; index += 1) {
      const progress = index / segments;
      const baseX = startX + (endX - startX) * progress;
      const baseY = startY + (endY - startY) * progress;
      const drift = 1 - Math.abs(0.5 - progress) * 1.35;

      points.push({
        x: clamp(baseX + random(-width * 0.11, width * 0.11) * drift, -width * 0.14, width * 1.14),
        y: clamp(baseY + random(-height * 0.06, height * 0.06), -height * 0.14, height * 1.14),
      });
    }

    points.push({ x: endX, y: endY });

    return points;
  }

  function buildBranchPoints(points, width, height) {
    if (points.length < 4) return null;

    const startIndex = randomInt(1, points.length - 3);
    const start = points[startIndex];
    const direction = Math.random() < 0.5 ? -1 : 1;
    const branch = [{ x: start.x, y: start.y }];
    const segments = randomInt(3, 5);

    let currentX = start.x;
    let currentY = start.y;

    for (let index = 0; index < segments; index += 1) {
      currentX += direction * random(width * 0.03, width * 0.09);
      currentY += random(height * 0.04, height * 0.11);

      branch.push({
        x: clamp(currentX, -width * 0.12, width * 1.12),
        y: clamp(currentY, -height * 0.12, height * 1.12),
      });
    }

    return branch;
  }

  function updateViewBox(layer) {
    const svg = layer.querySelector('.home-lightning__svg');

    if (!svg) return;

    const rect = layer.getBoundingClientRect();
    const width = Math.max(1, Math.round(rect.width));
    const height = Math.max(1, Math.round(rect.height));

    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  }

  function animateFlash(flash, xPercent, yPercent, duration, delay) {
    flash.style.setProperty('--flash-x', `${xPercent}%`);
    flash.style.setProperty('--flash-y', `${yPercent}%`);

    if (!flash.animate) return;

    flash.animate(
      [
        { opacity: 0 },
        { opacity: 0.6, offset: 0.1 },
        { opacity: 0.36, offset: 0.28 },
        { opacity: 0.18, offset: 0.58 },
        { opacity: 0.06, offset: 0.84 },
        { opacity: 0 },
      ],
      {
        duration: Math.round(duration * 1.45),
        delay,
        easing: 'cubic-bezier(0.18, 0.84, 0.32, 1)',
      }
    );
  }

  function animateStroke(path, duration, delay, peakOpacity) {
    const length = path.getTotalLength();

    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;

    if (!path.animate) return;

    path.animate(
      [
        { strokeDashoffset: length, opacity: 0 },
        { strokeDashoffset: length * 0.1, opacity: peakOpacity * 0.92, offset: 0.14 },
        { strokeDashoffset: 0, opacity: peakOpacity, offset: 0.24 },
        { strokeDashoffset: 0, opacity: peakOpacity * 0.58, offset: 0.54 },
        { strokeDashoffset: 0, opacity: peakOpacity * 0.18, offset: 0.82 },
        { strokeDashoffset: 0, opacity: 0 },
      ],
      {
        duration: Math.round(duration * 1.28),
        delay,
        easing: 'cubic-bezier(0.18, 0.82, 0.28, 1)',
        fill: 'forwards',
      }
    );
  }

  function spawnBolt(layer, delay) {
    const svg = layer.querySelector('.home-lightning__svg');
    const boltsLayer = svg ? svg.querySelector('.home-lightning__bolts') || svg : null;
    const flash = layer.querySelector('.home-lightning__flash');

    if (!svg || !boltsLayer || !flash) return;

    const width = layer.clientWidth;
    const height = layer.clientHeight;

    if (!width || !height) return;

    const points = buildBoltPoints(width, height);
    const branches = [];
    const branchCount = Math.random() < 0.66 ? randomInt(1, 2) : 0;

    for (let index = 0; index < branchCount; index += 1) {
      const branch = buildBranchPoints(points, width, height);

      if (branch) branches.push(branch);
    }

    const bolt = document.createElementNS(SVG_NS, 'g');
    bolt.setAttribute('data-lightning-bolt', 'true');
    const duration = randomInt(760, 1100);
    const mainPath = pointsToPath(points);

    bolt.appendChild(
      createPath('home-lightning__path home-lightning__path--outer', mainPath, 'home-lightning-filter-outer')
    );
    bolt.appendChild(
      createPath('home-lightning__path home-lightning__path--mid', mainPath, 'home-lightning-filter-mid')
    );
    bolt.appendChild(
      createPath('home-lightning__path home-lightning__path--core', mainPath, 'home-lightning-filter-core')
    );

    branches.forEach((branch) => {
      const branchPath = pointsToPath(branch);

      bolt.appendChild(
        createPath(
          'home-lightning__path home-lightning__path--branch-glow',
          branchPath,
          'home-lightning-filter-branch'
        )
      );
      bolt.appendChild(
        createPath('home-lightning__path home-lightning__path--branch', branchPath, 'home-lightning-filter-core')
      );
    });

    boltsLayer.appendChild(bolt);

    const flashPoint = points[randomInt(1, points.length - 2)];

    animateFlash(flash, (flashPoint.x / width) * 100, (flashPoint.y / height) * 100, duration, delay);

    bolt.querySelectorAll('.home-lightning__path').forEach((path) => {
      let peakOpacity = 0.96;

      if (path.classList.contains('home-lightning__path--outer')) peakOpacity = 0.52;
      if (path.classList.contains('home-lightning__path--mid')) peakOpacity = 0.78;
      if (path.classList.contains('home-lightning__path--core')) peakOpacity = 0.98;
      if (path.classList.contains('home-lightning__path--branch-glow')) peakOpacity = 0.46;
      if (path.classList.contains('home-lightning__path--branch')) peakOpacity = 0.82;

      animateStroke(path, duration, delay, peakOpacity);
    });

    window.setTimeout(() => {
      bolt.remove();
    }, delay + Math.round(duration * 1.45) + 180);
  }

  function scheduleNextStrike(layer, fastStart = false) {
    const state = layer._lightningState;

    if (!state) return;

    window.clearTimeout(state.timer);

    if (motionQuery.matches) return;

    state.timer = window.setTimeout(
      () => {
        if (document.visibilityState === 'hidden') {
          scheduleNextStrike(layer);
          return;
        }

        updateViewBox(layer);

        const burstCount = Math.random() < 0.26 ? randomInt(2, 3) : 1;

        for (let index = 0; index < burstCount; index += 1) {
          spawnBolt(layer, index * randomInt(180, 320));
        }

        scheduleNextStrike(layer);
      },
      fastStart ? randomInt(700, 1400) : randomInt(2400, 5200)
    );
  }

  function initLayer(layer) {
    if (layer.dataset.lightningReady === 'true') return;

    layer.dataset.lightningReady = 'true';
    layer._lightningState = { timer: null };

    updateViewBox(layer);

    const observedTarget = layer.parentElement || layer;

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => updateViewBox(layer));
      resizeObserver.observe(observedTarget);
      layer._lightningState.resizeObserver = resizeObserver;
    } else {
      window.addEventListener('resize', () => updateViewBox(layer), { passive: true });
    }

    if (!motionQuery.matches) {
      scheduleNextStrike(layer, true);
    }
  }

  function initAll() {
    document.querySelectorAll('.home-lightning').forEach(initLayer);
  }

  function handleMotionChange() {
    document.querySelectorAll('.home-lightning').forEach((layer) => {
      const state = layer._lightningState;
      const flash = layer.querySelector('.home-lightning__flash');
      const svg = layer.querySelector('.home-lightning__svg');

      if (!state || !flash || !svg) return;

      window.clearTimeout(state.timer);

      if (motionQuery.matches) {
        flash.style.opacity = '0';
        svg.querySelectorAll('[data-lightning-bolt]').forEach((bolt) => bolt.remove());
        return;
      }

      scheduleNextStrike(layer, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  if (motionQuery.addEventListener) {
    motionQuery.addEventListener('change', handleMotionChange);
  } else if (motionQuery.addListener) {
    motionQuery.addListener(handleMotionChange);
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !motionQuery.matches) {
      document.querySelectorAll('.home-lightning').forEach((layer) => {
        scheduleNextStrike(layer, true);
      });
    }
  });

  document.addEventListener('shopify:section:load', initAll);
})();
